interface SectionHeadingProps {
  index: string;
  kicker: string;
  title: string;
  desc?: string;
}

export default function SectionHeading({ index, kicker, title, desc }: SectionHeadingProps) {
  return (
    <div className="w-full">
      <div className="flex items-center gap-3">
        <span className="font-label text-xs tracking-[0.28em] text-primary-600">{index}</span>
        <span className="h-px flex-1 bg-background-300"></span>
        <span className="font-label text-xs tracking-[0.2em] text-foreground-500">{kicker}</span>
      </div>
      <h2 className="mt-4 font-heading text-2xl md:text-3xl font-bold text-foreground-950 leading-snug">{title}</h2>
      {desc && <p className="mt-3 text-sm text-foreground-600 max-w-3xl leading-relaxed font-body">{desc}</p>}
    </div>
  );
}